import axios from 'axios';
import { getUserIP } from '../hooks/getUserIP';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const api = axios.create({ baseURL: BASE_URL, headers: { 'Content-Type': 'application/json' } });

const fetchMessage = async (url: string, ipReq: boolean) => {
  const userIP = ipReq ? await getUserIP() : "";

  try {
    const response = await api.get(url, {
      headers: {
        'X-Forwarded-For': userIP,
      },
    });
    return response.data;
  }
  catch (error: any) {
    toast.error(error || '', { position: "top-right", autoClose: 3000 })
  }
};

const postMessage = async (url: string, data: any, ipReq: boolean) => {
  const userIP = ipReq ? await getUserIP() : "";

  try {
    const response = await api.post(url, data, {
      headers: {
        'X-Forwarded-For': userIP,
      },
    });
    return response.data;
  }
  catch (error: any) {
    toast.error(error || '', { position: "top-right", autoClose: 3000 })
  }
};

export { fetchMessage, postMessage };
